import React from 'react';

import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { GeneralError } from '@/views/generalError/GeneralError.view.tsx';

export const Forbidden: React.FC = () => {
  const { t } = useTranslationWithPrefix('generalError.forbidden');

  return <GeneralError hideButton message={t('message')} subMessage={t('subMessage')} />;
};
